import Toast from './Toast'
import { publish } from '../../utils/events'

/**
 * Muestra un toast de éxito
 * @param {string} message - Mensaje a mostrar
 * @param {number} duration - Duración en milisegundos (default: 5000)
 */
export const toastSuccess = (message, duration = 5000) => {
  publish('show-toast', { type: 'success', message, duration })
}

/**
 * Muestra un toast de error
 * @param {string} message - Mensaje a mostrar
 * @param {number} duration - Duración en milisegundos (default: 5000)
 */
export const toastError = (message, duration = 5000) => {
  publish('show-toast', { type: 'error', message, duration })
}

/**
 * Muestra un toast de advertencia
 * @param {string} message - Mensaje a mostrar
 * @param {number} duration - Duración en milisegundos (default: 5000)
 */
export const toastWarning = (message, duration = 5000) => {
  publish('show-toast', { type: 'warning', message, duration })
}

/**
 * Muestra un toast de información
 * @param {string} message - Mensaje a mostrar
 * @param {number} duration - Duración en milisegundos (default: 5000)
 */
export const toastInfo = (message, duration = 5000) => {
  publish('show-toast', { type: 'info', message, duration })
}

export default Toast

